import { Link, withRouter } from 'react-router-dom';
import React, { Component, Fragment } from 'react';

import { Error } from '../../shared/Error/Error';
import { LoadingIndicator } from '../../shared/LoadingIndicator/LoadingIndicator';
import Parser from 'html-react-parser';
import PropTypes from 'prop-types';
import { formatDate } from '../../../utils/dateUtils';
const md = require('markdown-it')({ html: true }).use(require('markdown-it-sanitizer'));

// COMPONENT
class MonitoredDocumentViewer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { onInitialLoad, loadMarkdown, loadVersions } = this.props;

        onInitialLoad()
            .then(() => {
                loadMarkdown();
                loadVersions();
            })
            .catch(err => {
                console.log(err);
            });
    }

    render() {
        const {
            fetchedMarkdown,
            fetchingMarkdown,
            failedMarkdown,
            markdown,
            versionId,
            documentId,
            backLink,
            monitoredDocumentVersions,
            monitoredDocumentVersion,
            fetchedMonitoredDocumentVersion,
            fetchingMonitoredDocumentVersion,
            failedMonitoredDocumentVersion,
            match,
        } = this.props;

        if (
            (fetchedMarkdown && !fetchedMarkdown) ||
            (fetchedMonitoredDocumentVersion && !fetchedMonitoredDocumentVersion)
        ) {
            return <LoadingIndicator busy={fetchingMarkdown || fetchingMonitoredDocumentVersion} />;
        } else if (failedMarkdown || failedMonitoredDocumentVersion) {
            return (
                <Error
                    message={
                        failedMarkdown
                            ? 'Failed to fetch monitored document record'
                            : 'Failed to fetch monitored document version'
                    }
                />
            );
        } else {
            const markdownHtml = md.render(markdown);

            return (
                <div className="card">
                    <div className="card-body">
                        <div className="card-title">
                            <div className="d-flex justify-content-between w-100">
                                <h4>
                                    {name ? name : 'Monitored Document'}
                                    <small className="text-muted">Monitored Document</small>
                                </h4>
                                <div>
                                    <small>
                                        {monitoredDocumentVersion.updated
                                            ? formatDate(monitoredDocumentVersion.updated)
                                            : formatDate(monitoredDocumentVersion.created)}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0" style={{ height: '600px' }}>
                        <div className="compare">
                            <div className="container" style={{ height: '600px' }}>
                                {Parser(markdownHtml)}
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="d-flex justify-content-between w-100">
                            <div>
                                {monitoredDocumentVersion.comment
                                    ? monitoredDocumentVersion.comment
                                    : 'No comment'}
                            </div>

                            {monitoredDocumentVersions && monitoredDocumentVersions.length && (
                                <Fragment>
                                    <div
                                        className="btn-group"
                                        role="group"
                                        aria-label="Compare monitored document versions"
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-info"
                                            data-toggle="dropdown"
                                        >
                                            Compare To
                                        </button>
                                        <div className="btn-group" role="group">
                                            <button
                                                id="btnGroupDrop2"
                                                type="button"
                                                className="btn btn-info dropdown-toggle"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            />
                                            <div
                                                className="dropdown-menu"
                                                aria-labelledby="btnGroupDrop2"
                                            >
                                                {monitoredDocumentVersions
                                                    .filter(item => {
                                                        return item.s3Version !== versionId;
                                                    })
                                                    .sort((a, b) => {
                                                        return b.created - a.created;
                                                    })
                                                    .map(option => (
                                                        <Link
                                                            className="dropdown-item"
                                                            to={{
                                                                pathname: `/monitored-document/${documentId}/compare/${[
                                                                    option.s3Version,
                                                                    versionId,
                                                                ].toString()}`,
                                                                state: {
                                                                    backLink: match.url,
                                                                },
                                                            }}
                                                            key={option.s3Version}
                                                        >
                                                            {formatDate(option.created)}
                                                        </Link>
                                                    ))}
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            )}

                            <div>
                                {backLink && (
                                    <Link to={backLink}>
                                        <button type="button" className="btn btn-secondary">
                                            Close
                                        </button>
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

MonitoredDocumentViewer.propTypes = {
    onInitialLoad: PropTypes.func.isRequired,
    loadMarkdown: PropTypes.func.isRequired,
    fetchedMarkdown: PropTypes.bool.isRequired,
    fetchedMonitoredDocumentVersion: PropTypes.bool.isRequired,
    fetchingMarkdown: PropTypes.bool.isRequired,
    fetchingMonitoredDocumentVersion: PropTypes.bool.isRequired,
    documentId: PropTypes.string.isRequired,
    versionId: PropTypes.string.isRequired,
    loadVersions: PropTypes.func.isRequired,
    markdown: PropTypes.string,
    monitoredDocumentVersion: PropTypes.object,
    failedMarkdown: PropTypes.bool,
    failedMonitoredDocumentVersion: PropTypes.bool,
    backLink: PropTypes.string,
    monitoredDocumentVersions: PropTypes.array,
    match: PropTypes.object,
};

export default withRouter(MonitoredDocumentViewer);
